import { 
  collection, 
  getDocs, 
  query, 
  orderBy, 
  where 
} from 'firebase/firestore';
import { db } from './config';

// Fetch all projects from Firestore
export const fetchProjects = async () => {
  try {
    const projectsRef = collection(db, 'projects');
    const q = query(projectsRef, orderBy('title'));
    const querySnapshot = await getDocs(q);
    
    const projects = [];
    querySnapshot.forEach((doc) => {
      projects.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return projects;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

// Fetch all news from Firestore
export const fetchNews = async () => {
  try {
    const newsRef = collection(db, 'news');
    const q = query(newsRef, orderBy('date', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const news = [];
    querySnapshot.forEach((doc) => {
      news.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return news;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

// Fetch all gallery items from Firestore
export const fetchGallery = async () => {
  try {
    const galleryRef = collection(db, 'gallery');
    const q = query(galleryRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const gallery = [];
    querySnapshot.forEach((doc) => {
      gallery.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return gallery;
  } catch (error) {
    console.error('Error fetching gallery:', error);
    throw error;
  }
};

// Fetch all careers from Firestore
export const fetchCareers = async () => {
  try {
    const careersRef = collection(db, 'careers');
    const q = query(careersRef, orderBy('jobTitle'));
    const querySnapshot = await getDocs(q);
    
    const careers = [];
    querySnapshot.forEach((doc) => {
      careers.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return careers;
  } catch (error) {
    console.error('Error fetching careers:', error);
    throw error;
  }
};

// Fetch featured projects (with category filter)
export const fetchFeaturedProjects = async () => {
  try {
    const projectsRef = collection(db, 'projects');
    const q = query(projectsRef, where('featured', '==', true), orderBy('title'));
    const querySnapshot = await getDocs(q);
    
    const projects = [];
    querySnapshot.forEach((doc) => {
      projects.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return projects;
  } catch (error) {
    console.error('Error fetching featured projects:', error);
    throw error;
  }
};

// Fetch gallery by category
export const fetchGalleryByCategory = async (category) => {
  try {
    const galleryRef = collection(db, 'gallery');
    const q = query(
      galleryRef, 
      where('category', '==', category),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    
    const gallery = [];
    querySnapshot.forEach((doc) => {
      gallery.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return gallery;
  } catch (error) {
    console.error('Error fetching gallery by category:', error);
    throw error;
  }
};
